import BtnLink from "../../Components/UI/BtnLink";
import styles from "./legal.module.css";
import { Link } from "react-router-dom";

function Legal() {
  return (
    <main className={styles.legal}>
      <h1>MENTIONS LÉGALES</h1>
      <div>
        <p>
          Ce site est édité par TradingHelper. L’information communiquée sur ce
          site est présentée à titre indicatif et général.
        </p>
        <h3>CONCEPTION et GESTION ÉDITORIALE</h3>
        <p>
          TradingHelper | Trading &amp; Zen Attitude
          <br />
          <span>14 rue du bleb</span>
          <br />
          44200 Naoned City, France
          <br />
          Téléphone : 06 00 00 00 00
          <br />
          E-mail : contact [@] TradingHelper.com
        </p>
        <h4>DIRECTION DE PUBLICATION</h4>
        <p>Cyrille Tual</p>
        <h4>HÉBERGEMENT</h4>
        <p>
          OVH &#8211; 2 rue Kellermann – 59100 Roubaix
          <br />
          https://www.ovh.com
        </p>
        <h3>TITULARITÉ DES DROITS</h3>
        <p>
          Tous les éléments de ce site Internet (notamment les marques
          déposées,noms de domaine, les textes graphismes, logos, sons, photos,
          animations et codes) sont la propriété des éditeurs de ce site, à
          l’exclusion des éléments émanant de vos partenaires ou de partenaires
          de TradingHelper. Toute reproduction et/ou représentation et/ou
          rediffusion, en tout ou partie, sur tout support électronique ou non,
          présent ou futur, sont interdites sauf autorisation expresse et
          préalable. Le non-respect de cette interdiction est susceptible de
          constituer un acte de contrefaçon engageant les responsabilités civile
          et pénale de tout contrevenant. Le logiciel gérant les contenus de ce
          site est placé sous licence GPL ainsi que l’ensemble des agréments
          techniques et extensions associés.
        </p>
        <h3>MISE EN PLACE DE LIENS HYPERTEXTES</h3>
        <p>
          Nous vous informons que tout site Internet ou tout autre support est
          autorisé à citer votre URL ou à mettre en place un lien hypertexte
          pointant vers l’adresse de votre site.
        </p>
        <p>
          L’autorisation de mise en place d’un lien est valable pour tout
          support, à l’exception de ceux diffusant des informations à caractère
          politique, religieux, pornographique, xénophobe ou pouvant porter
          atteinte à la sensibilité du plus grand nombre. Au titre de cette
          autorisation, notre équipe se réserve un droit d’opposition. En outre,
          dans le cadre de la mise en place d’un lien hypertexte sur votre site,
          nous vous accordons également le droit de reproduire notre logo dans
          la seule limite de la mise en place dudit lien et du référencement en
          vigueur. A ce titre, le format et la charte du logo devront être
          respectés.
        </p>
        <p>
          L’utilisateur est seul responsable de cette utilisation. De plus, le
          présent site peut avoir été, à son insu, relié à d’autres sites par
          des liens hypertextes, TradingHelper n’autorise pas ce type de liens
          ni de pratiques.
        </p>
        <h3>COMMENTAIRES</h3>
        <p>
          TradingHelper autorise les internautes à publier des commentaires sur
          le site. Toutefois les commentaires n’ayant aucun rapport avec le
          contenu du site seront considérés comme du spam et par conséquent
          supprimés. Les commentaires injurieux ou ayant des connotations
          racistes, violentes ou sexuelles seront également supprimés.
        </p>
        <h3>RESPONSABILITÉ</h3>
        <p>
          Malgré tous les soins apportés à la réalisation et aux mises à jour du
          contenu du site, Pulse ne peut être tenu pour responsable de la
          modification des dispositions juridiques, ou de tout ordre, survenant
          après la publication. Ce site est soumis à la loi française et les
          tribunaux compétents sont les tribunaux français.
        </p>
        <p>
          TradingHelper décline toute responsabilité quant aux éventuels
          dysfonctionnements pouvant survenir sur le site et entraîner une perte
          de données ou une indisponibilité de l’accès aux informations
          produites sur celui-ci. TradingHelper ne peut garantir l’exhaustivité
          et la véracité de toutes les informations présentes sur le site ainsi
          que l’absence de modification par un tiers (intrusion, virus).
          L’internaute est seul responsable de l’utilisation qu’il fait du
          contenu du site.
        </p>
        <p>
          Les éléments présentés sur le Site sont susceptibles de modification
          sans préavis et sont mis à la disposition des internautes, sans aucune
          garantie d’aucune sorte, expresse ou tacite.
        </p>
        <p>
          La présence de liens hypertextes présents sur le site ne crée pas une
          solidarité de responsabilité entre TradingHelper et les propriétaires
          des autres sites, quant au contenu des sites sur lesquels est redirigé
          l’internaute. Seule la responsabilité desdits sites peut être engagée.
        </p>
        <p>
          Il est important de rappeler les risques inhérents à la transmission
          électronique d’informations : des retards, omissions ou inexactitudes
          sont susceptibles de se produire.
        </p>
      </div>
      <div>
        <h2>POLITIQUE DE CONFIDENTIALITÉ</h2>
        <p>
          Cette page vous explique nos politiques en matière de collecte,
          d’utilisation et de communication des données à caractère personnel
          lorsque vous utilisez notre Service ainsi que les choix qui s’offrent
          à vous en ce qui concerne ces données. Nous utilisons vos données pour
          fournir et améliorer le Service. En utilisant le Service, vous
          consentez à la collecte et à l’utilisation d’informations conformément
          à la présente politique.
        </p>
        <h3>Collecte et utilisation des données</h3>
        <h4>DONNÉES À CARACTÈRE PERSONNEL</h4>
        <p>
          Lorsque vous utilisez notre service, il est possible que nous vous
          demandions de nous fournir certaines données personnelles nominatives
          qui peuvent servir à vous contacter ou à vous identifier (« Données à
          Caractère Personnel »). Les données personnelles nominatives peuvent
          comprendre, mais de manière non limitative:
        </p>
        <ul>
          <li>Adresse e-mail</li>
          <li>Nom et/ou appellation société</li>
          <li>Numéro de téléphone</li>
          <li>Adresse postale</li>
          <li>Age</li>
          <li>Préférences sportives et niveau</li>
          <li>Infos sanitaires en cas d&#8217;accident</li>
          <li>Autorisation parentale</li>
          <li>Dates des vacances et préférences</li>
          <li>Signature électronique</li>
          <li>Détails de commande</li>
          <li>Données bancaires (cryptées)</li>
          <li>Cookies et Données d’Utilisation</li>
        </ul>
        <h4>UTILISATION DES DONNÉES</h4>
        <ul>
          <li>
            Traiter vos demandes de contact/devis/inscription/abonnement et
            commandes faites à partir des formulaires présents sur notre site
            Web. À ce titre, une notification d&#8217;acceptation RGPD apparaît
            à chaque soumission.
          </li>
          <li>
            Gérer les commentaires sur les articles d&#8217;actualité, produits
            ou portfolio. À ce titre, une notification d&#8217;acceptation RGPD
            apparaît à chaque soumission.
          </li>
          <li>
            Établir des statistiques de fréquentation du site internet
            permettant son amélioration. À ce titre, une notification de
            présence de cookies apparaît à chaque session d’un visiteur.
          </li>
          <li>
            Gestion technique du site (maintenance, hébergement, sécurité du
            site) et des comptes
          </li>
        </ul>
        <figure>
          <table>
            <tbody>
              <tr>
                <td>Finalité</td>
                <td>Base juridique</td>
                <td>Durée de conservation</td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td>Contacts / commandes</td>
                <td>Consentement</td>
                <td>Conservation : 5 ans</td>
              </tr>
              <tr>
                <td>Commentaires aux articles</td>
                <td>Consentement</td>
                <td>Conservation : 5 ans</td>
              </tr>
              <tr>
                <td>Statistiques d’audience</td>
                <td>Consentement</td>
                <td>Conservation : 36 mois</td>
              </tr>
              <tr>
                <td>Gestion technique</td>
                <td>Intérêt légitime</td>
                <td>
                  Conservation : tant que les personnes concernées administrent
                  le service.
                </td>
              </tr>
            </tbody>
          </table>
        </figure>
        <p>
          Suppression des données stockées dans un délai d’un mois à compter de
          la notification reçue par e-mail ou courrier.
        </p>
        <p>
          Vous pouvez choisir de ne recevoir aucune communication de notre part
          ou de ne recevoir que certaines communications en cliquant sur le lien
          de désabonnement ou en suivant les instructions qui figurent dans les
          e-mails que nous envoyons.
        </p>
        <p>
          Nous pouvons également recueillir des informations relatives au mode
          d’accès et d’utilisation du Service (« Données d’Utilisation »). Ces
          Données d’Utilisation peuvent comprendre des informations telles que
          l’adresse de protocole Internet (c.-à-d. l’adresse IP) de votre
          ordinateur, le type de navigateur, la version du navigateur, les pages
          de notre Service que vous consultez, la date et l’heure de votre
          visite, le temps passé sur ces pages, les identifiants uniques de
          dispositifs ainsi que d’autres données de diagnostic.
        </p>
        <h3>Suivi et données de cookies</h3>
        <p>
          Nous avons recours à des cookies pour effectuer un suivi des activités
          effectuées dans notre service, et nous conservons certaines
          informations. Les cookies sont des fichiers à faible volume de données
          pouvant comporter un identifiant unique anonyme. Les cookies sont
          envoyés à votre navigateur depuis un site web et sont stockés sur
          votre dispositif. D’autres technologies de suivi telles que les
          pixels, les balises et les scripts sont également utilisées pour
          recueillir et suivre des informations et afin d’améliorer et
          d’analyser notre service.
        </p>
        <p>
          Vous pouvez demander à votre navigateur de refuser tous les cookies ou
          de vous avertir lorsqu’un cookie est envoyé. Toutefois, si vous
          n’acceptez pas les cookies, il se peut que vous ne puissiez pas
          utiliser certains éléments de notre service.
        </p>
        <p>
          <strong data-rich-text-format-boundary="true">
            Les cookies de session sont limités à une durée de vie de 13 mois
            maximum
          </strong>
          .
        </p>
        <p>Exemples de cookies que nous utilisons :</p>
        <ul>
          <li>
            Cookies de Session. Nous utilisons des Cookies de Session pour faire
            fonctionner notre service.
          </li>
          <li>
            Cookies de Préférences. Nous utilisons des Cookies de Préférences
            pour mémoriser vos préférences et vos différents paramètres.
          </li>
          <li>
            Cookies de Sécurité. Nous utilisons des Cookies de Sécurité pour des
            raisons de sécurité.
          </li>
        </ul>
        <h4>CONSERVATION DES DONNÉES</h4>
        <p>
          Conformément au RGPD, vous pouvez accéder aux données à caractère
          personnel vous concernant ou demander leur effacement. Vous disposez
          également d’un droit d’opposition, de rectification et de limitation
          du traitement de vos données. Pour exercer ces droits ou pour toute
          question sur le traitement de vos données par TradingHelper, vous
          pouvez nous contacter{" "}
          <Link to="#">par voie électronique en cliquant sur ce lien</Link> ou
          par courrier postal.
        </p>
        <h4>DESTINATAIRES DES DONNÉES PERSONNELLES</h4>
        <p>
          Toutes les données à caractère personnel collectées restent sous le
          contrôle exclusif de TradingHelper et ne sont jamais communiquées ni
          commercialisées. Les destinataires des données personnelles sont
          TradingHelper et ses prestataires contractuellement conformes à la
          règlementation en vigueur chargés de leur traitement.
        </p>
        <h4>COMMUNICATION DES DONNÉES</h4>
        <h5>Communication de données aux forces de l’ordre</h5>
        <p>
          Dans certaines circonstances, TradingHelper peut être tenue de
          communiquer vos Données à Caractère Personnel si la loi l’exige ou en
          réponse à des demandes valides émanant de pouvoirs publics (par ex. un
          tribunal ou un organisme gouvernemental).
        </p>
        <h5>Exigences légales</h5>
        <p>
          TradingHelper peut communiquer vos Données à Caractère Personnel si
          elle estime de bonne foi que cela est nécessaire pour :
        </p>
        <ul>
          <li>S’acquitter d’une obligation légale</li>
          <li>Protéger et défendre les droits ou les biens de TradingHelper</li>
          <li>
            Prévenir d’éventuels actes répréhensibles ou enquêter sur de tels
            actes dans le cadre du Service
          </li>
          <li>
            Assurer la sécurité personnelle des utilisateurs du Service ou du
            public
          </li>
          <li>Se protéger contre la responsabilité civile</li>
        </ul>
        <h3>Sécurité des données</h3>
        <p>
          La sécurité de vos données nous tient à cœur. Toutefois, n’oubliez pas
          qu’aucune méthode de transmission de données par Internet ou méthode
          de stockage électronique n’est sûre à 100 %. Bien que nous nous
          efforcions d’utiliser des méthodes commercialement acceptables pour
          protéger vos Données à Caractère Personnel, nous ne pouvons pas leur
          garantir une sécurité absolue.
        </p>
        <p>
          Droits à la protection des données qui vous sont accordés par le
          Règlement Général relatif à la Protection des Données (RGPD)
        </p>
        <p>
          Si vous résidez dans l’Espace économique européen (EEE), vous avez
          certains droits en matière de protection des données. TradingHelper
          entend prendre des mesures raisonnables pour vous permettre de
          corriger, de modifier, ou de supprimer vos Données à Caractère
          Personnel ou d’en limiter l’utilisation. Si vous souhaitez savoir
          quelles Données à Caractère Personnel nous détenons à votre sujet et
          voulez qu’elles soient supprimées de nos systèmes, veuillez nous
          contacter.
        </p>
        <p>
          Dans certaines circonstances, vous avez les droits suivants en matière
          de protection des données:
        </p>
        <ul>
          <li>
            Le droit d’accéder aux informations que nous détenons à votre sujet,
            de les actualiser ou de les supprimer. Lorsque cette option est
            proposée, vous pouvez consulter ou actualiser vos Données à
            Caractère Personnel ou en demander la suppression dans la section
            paramètres de votre compte. Si vous ne pouvez pas effectuer ces
            actions vous-même, merci de nous contacter pour obtenir de l’aide.
          </li>
          <li>
            Droit de rectification. Vous avez le droit de faire rectifier vos
            données si elles sont inexactes ou incomplètes.
          </li>
          <li>
            Droit d’opposition. Vous avez le droit de vous opposer à ce que nous
            traitions vos Données à Caractère Personnel.
          </li>
          <li>
            Droit de limitation Vous avez le droit de nous demander de limiter
            le traitement de vos données personnelles.
          </li>
          <li>
            Le droit à la portabilité des données. Vous avez le droit de
            recevoir une copie des informations que nous détenons à votre sujet
            dans un format couramment utilisé, structuré et lisible par une
            machine.
          </li>
          <li>
            Droit au retrait du consentement. Vous avez également le droit de
            retirer votre consentement à tout moment si TradingHelper s’est
            appuyé sur votre consentement pour traiter vos données personnelles.
          </li>
        </ul>
        <p>
          Veuillez noter que nous pouvons vous demander de prouver votre
          identité avant de répondre à des demandes de cette nature.
        </p>
        <h3>PRESTATAIRES DE SERVICES</h3>
        <p>
          Nous pouvons faire appel à des Prestataires de Services tiers pour
          surveiller et analyser l’utilisation de notre Service.
        </p>
        <ul>
          <li>
            Google Analytics : Bien que nous efforçant de travailler avec de +
            en + d&#8217;outils français, nous utilisons toujours Google
            Analytics qui est l&#8217;un des meilleurs services d’analyse web
            proposé par Google. Ce outil assure le suivi du trafic d’un site web
            et en rend compte. Google utilise les données recueillies pour
            suivre et surveiller l’utilisation de notre Service. Ces données
            sont partagées avec d’autres services Google. Google peut utiliser
            les données recueillies pour contextualiser et personnaliser les
            annonces de son propre réseau publicitaire. Pour plus de précisions
            sur les pratiques de confidentialité de Google, merci de consulter{" "}
            <a
              href="https://policies.google.com/privacy?hl=fr"
              target="_blank"
              rel="noreferrer noopener"
            >
              la page web Protection de la vie privée et conditions de Google
            </a>
            .
          </li>
        </ul>
        <h3>EXERCICE DE DROIT</h3>
        <p>
          Conformément au Règlement (UE) 2016/679 du Parlement européen et du
          Conseil du 27 avril 2016 relatif à la protection des personnes
          physiques à l’égard du traitement des données à caractère personnel et
          à la libre circulation de ces données, vous disposez d’un droit
          d’accès aux données, de rectification des données, d’effacement des
          données, de limitation du traitement, d’opposition au traitement dans
          les conditions légales applicables.
        </p>
        <p>
          Vous avez le droit de déposer plainte auprès d’une autorité de
          protection des données au sujet de notre collecte et de notre
          utilisation de vos Données à Caractère Personnel. Pour plus de
          précisions, veuillez contacter l’autorité de protection des données la
          plus proche de vous dans l’Espace économique européen (EEE).
        </p>
        <h3>NOUS CONTACTER</h3>
        <p>
          Pour toute question relative à la présente Politique de
          Confidentialité, veuillez{" "}
          <Link to="#">nous contacter en cliquant ici</Link>{" "}
        </p>
      </div>
      <div className={styles.center}><BtnLink link="/" title= "Acceuil" name="acceuil"/></div>
      
    </main>
  );
}

export default Legal;
